import { render, staticRenderFns } from "./SwiperImg.vue?vue&type=template&id=5467760e&"
import script from "./SwiperImg.vue?vue&type=script&lang=js&"
export * from "./SwiperImg.vue?vue&type=script&lang=js&"
import style0 from "./SwiperImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports